module.exports = "/_next/static/images/game-2-menu-social-slide-2-696d7ea5a1dc670b35e9c978af9ed003.png";